export default "https://cdn-static.gokick.com/assets/c66ec253f0896645bf734992981ccce4219a90e3/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";